import styled from 'styled-components';
import { Image } from '@lt/components';

export const StyledLink = styled.a`
  text-decoration: none;
`;

export const StyledContainer = styled.div<{
  $backgroundColor: string;
  $textColor: string;
}>`
  z-index: 1002;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: relative;

  width: 100%;
  height: 60px;

  background-color: ${({ $backgroundColor }) => $backgroundColor};
  color: ${({ $textColor }) => $textColor};

  font-weight: bold;
  text-transform: uppercase;
`;

export const StyledImageWrapper = styled.div<{ $isMobile: boolean }>`
  ${({ $isMobile }) =>
    $isMobile
      ? `
      margin-right: 5px;
      `
      : `
      width: 30px;
      height: 30px;
  `}

  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const StyledImage = styled(Image)<{ $isMobile: boolean }>`
  width: ${({ $isMobile }) => ($isMobile ? 20 : 30)}px;
  height: ${({ $isMobile }) => ($isMobile ? 20 : 30)}px;
`;

export const StyledText = styled.span<{
  $isMobile: boolean;
  $isHeading: boolean;
}>`
  font-size: ${({ $isMobile, $isHeading }) =>
    ($isMobile && $isHeading && '4vw') ||
    ($isMobile && !$isHeading && '2.5vw') ||
    (!$isMobile && '16px')};

  line-height: ${({ $isMobile, $isHeading }) =>
    ($isMobile && !$isHeading && '3vw') || (!$isMobile && '19px')};
`;

export const StyledDesktopContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledTextWrapper = styled.div<{ $isMobile: boolean }>`
  display: flex;

  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};

  justify-content: center;
  align-items: center;

  margin-left: 10px;
  letter-spacing: 0.02em;
`;

export const StyledFirstLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
